import { createFileRoute } from "@tanstack/react-router";
import { Row, Col, Container as Grid } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import Breadcrumb from "../../../../components/core/blocks/Breadcrumb";
import PriceLog from "../../../../modules/pricingv2/components/PriceLog";

const PriceChanges = () => {
  const { t } = useTranslation(["pricingv2"]);
  const breadCrumbItems = [{ name: t(($) => $.pricingv2["Price Log"]), href: "/user/pricing/changes" }];

  return (
    <>
      <Row style={{ marginBottom: "1rem" }}>
        <Col xs={12}>
          <Breadcrumb items={breadCrumbItems} />
        </Col>
      </Row>
      <div className="main-content" style={{ backgroundColor: "#FFF" }}>
        <Grid fluid style={{ minHeight: "calc(100vh - 150px)" }}>
          <PriceLog />
        </Grid>
      </div>
    </>
  );
};

export const Route = createFileRoute("/_authenticated/user/pricing/changes")({
  component: PriceChanges,
});
